import { Box, BoxProps } from '@mui/material';
import { useRef, useState } from 'react';
import { OTPInput } from './OTPInput';

export interface OTPContainerProps extends Omit<BoxProps, 'onChange'> {
  length?: number;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
}

export const OTPContainer: React.FC<OTPContainerProps> = ({
  length = 6,
  onChange,
  onComplete,
  ...props
}) => {
  const inputRefs = useRef<Array<any>>([]);
  const [otpValue, setOtpValue] = useState<string[]>(
    new Array(length).fill('')
  );

  const handleInputChange = (index: number, event: any) => {
    const value = event.target.value;
    if (value.length > 1) {
      event.target.value = value.slice(0, 1);
      return;
    }

    const newOtpValue = [...otpValue];
    newOtpValue[index] = value;
    setOtpValue(newOtpValue);

    // Call onChange with current OTP value
    const currentOtp = newOtpValue.join('');
    onChange?.(currentOtp);

    // Auto-focus next input
    if (value.length === 1 && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Check if OTP is complete
    if (currentOtp.length === length) {
      onComplete?.(currentOtp);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        mb: 1,
        width: '100%',
        justifyContent: 'space-between',
        maxWidth: 380,
      }}
      {...props}
    >
      {Array.from({ length }).map((_, index) => (
        <OTPInput
          key={index}
          index={index}
          onInputChange={handleInputChange}
          inputRef={(el) => (inputRefs.current[index] = el)}
        />
      ))}
    </Box>
  );
};

export default OTPContainer;
